import { Component, effect, inject, Input, OnChanges, output, SimpleChanges } from '@angular/core';
import { Loading } from '../../../components/loading/loading';
import { Table } from '../../../components/table/table';
import { ConfirmDialog } from '../../../components/confirm-dialog/confirm-dialog';
import { ConfirmDialogService } from '../../../services/confirm-dialog-service';
import { ColumnDef, flexRenderComponent } from '@tanstack/angular-table';
import { TefBoxService } from '../../../services/tef-box-service';
import { TableButtons } from '../../../components/table-buttons/table-buttons';
import { AdminService } from '../../../services/admin-service';
import Keycloak from 'keycloak-js';
import { ReactiveFormsModule } from '@angular/forms';
import { Modal } from '../../../components/modal/modal';
import { Button } from '../../../components/button/button';
import { Badge } from '../../../components/badge/badge';
import { ToastService } from '../../../services/toast-service';
import { ClienteService } from '../../../services/cliente-service';

interface Pos {
  status: string;
  posQuantity: number;
  linker: string;
  posLabel: string;
  serial: string;
  tid: string;
  mid: string;
  taxPayerId: string;
  model: string;
  libVersion: string;
  appName: string;
  appVersion: string;
  ready: boolean;
  config: number;
  online: boolean;
  lasConnection: number;
  posMessageId: number;
  posMessageTimestamp: number;
}

interface Pairing {
  linker: string;
  topicId: string;
  posLabel: string;
}

interface ITerminal {
  POS: Pos;
  Pairing: Pairing;
}

@Component({
  selector: 'app-terminal',
  imports: [ConfirmDialog, Table, Loading, ReactiveFormsModule, Modal],
  templateUrl: './terminal.html',
  styleUrl: './terminal.scss',
})
export class Terminal implements OnChanges {
  loading = false;

  columns: ColumnDef<ITerminal>[] = [
    // {
    //   id: 'select-col',
    //   header: () => flexRenderComponent(TableHeadSelectionComponent),
    //   cell: () => flexRenderComponent(TableRowSelectionComponent),
    // },
    {
      accessorKey: 'Pairing.posLabel',
      header: 'POS Label',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'POS.serial',
      header: 'Serial',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'POS.status',
      header: 'Transação',
      cell: (info) => {
        const status = info.getValue();
        const statusResponse: string = status != undefined ? `${info.getValue()}` : 'Pronto';

        return flexRenderComponent(Badge, {
          inputs: {
            texto: statusResponse,
            variant: statusResponse == 'Pronto' ? 'primary' : 'secondary',
          },
        });
      },
    },
    {
      accessorKey: 'POS.online',
      header: 'Online',
      cell: (info) => {
        var online: boolean = !!info.getValue();

        return `<div class="${online ? 'text-green-500' : 'text-red-500'} rounded-full h-3 w-3">${online ? 'Online' : 'Offline'}</div>`;
      },
    },
    {
      id: 'actions',
      enableHiding: false,
      header: 'Redefinir',
      cell: ({ row }) => {
        const checkout = row.original;
        return flexRenderComponent(TableButtons, {
          inputs: {
            title: 'reset',
          },
          outputs: {
            clickEvent: () => this.clearTerminalStatus(checkout.Pairing.linker),
          },
        });
      },
    },
  ];
  message = '';
  showConfirmDialog = false;
  data: ITerminal[] = [];

  role = 'lojista';

  @Input() title = '';

  @Input() showModal = false;

  @Input() merchantId: string | null = null;
  @Input() checkoutId: string | null = null;
  closeModal = output<void>();

  interval = 0;

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private tefBoxService: TefBoxService,
    private adminService: AdminService,
    private clienteService: ClienteService,
    private toast: ToastService,
  ) {
    const keycloak = inject(Keycloak);

    effect(() => {
      const clientRoles = keycloak.resourceAccess?.['tefbox-api-lojista'].roles || [];

      if (clientRoles.includes('admin')) {
        this.role = 'admin';
      }

      if (clientRoles.includes('cliente')) {
        this.role = 'cliente';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showModal'] && this.showModal === true) {
      this.loading = true;
      this.interval = setInterval(() => {
        this.getTerminals();
      }, 5000);
    } else if (changes['showModal'] && this.showModal === false) {
      clearInterval(this.interval);
    }
  }

  onConfirm() {
    this.confirmDialogService.confirm();
    this.showConfirmDialog = false;
  }

  onCancel() {
    this.confirmDialogService.cancel();
    this.showConfirmDialog = false;
  }

  clearTerminalStatus(linker: string) {
    switch (this.role) {
      case 'admin':
        this.adminService.clearTerminalStatus(this.merchantId!, linker).subscribe((resp) => {
          this.getTerminals();
          this.toast.show({
            message: 'Status redefinido com sucesso',
            type: 'success',
          });
        });
        break;
      case 'lojista':
        this.tefBoxService.clearTerminalStatus(linker).subscribe(() => {
          this.getTerminals();
          this.toast.show({
            message: 'Status redefinido com sucesso',
            type: 'success',
          });
        });
        break;
      case 'cliente':
        this.clienteService.clearTerminalStatus(this.merchantId!, linker).subscribe(() => {
          this.getTerminals();
          this.toast.show({
            message: 'Status redefinido com sucesso',
            type: 'success',
          });
        });
        break;
    }
  }

  getTerminals() {
    if (this.merchantId != null && this.checkoutId != null) {
      switch (this.role) {
        case 'lojista':
          this.tefBoxService.getTerminals(this.checkoutId).subscribe((resp) => {
            this.data = resp;
            this.loading = false;
          });
          break;
        case 'admin':
          this.adminService.getTerminals(this.merchantId, this.checkoutId).subscribe((resp) => {
            this.data = resp;
            this.loading = false;
          });
          break;

        case 'cliente':
          this.clienteService.getTerminals(this.merchantId, this.checkoutId).subscribe((resp) => {
            this.data = resp;
            this.loading = false;
          });
          break;
        default:
          console.log('Qual a role????');
          break;
      }
    }
  }

  fecharModal() {
    clearInterval(this.interval);
    this.closeModal.emit();
  }
}

@Component({
  selector: 'app-terminal-button',
  imports: [Button],
  template: ` <app-button (click)="abrirModal()">Terminais</app-button> `,
})
export class TerminalButton {
  @Input() id!: number;
  abrir = output<number>();

  abrirModal() {
    this.abrir.emit(this.id);
  }
}
